import initAxios from "./initAxios";

class ScenarioApi {
  constructor(apiUrl) {
    this.axios = initAxios({ baseURL: apiUrl, withCredentials: true });
  }

  scenarioAction = (scenario, body) =>
    this.axios.post(`v1/scenarios/${scenario}`, JSON.stringify(body));
}

export default ScenarioApi;
